import { useState } from 'react'
import effects from 'app/effects/effects'

export default () => {
  const [value, setValue] = useState(undefined)
  const [isLoading, setLoading] = useState(false)

  const getVoucherViewer = ({ vouchers, templateId }) => {
    setLoading(true)
    effects.apis
      .getVoucherView({
        html: vouchers.description,
        voucherTemplateId: templateId,
        isStyle: false,
      })
      .then((response) => {
        setValue(response)
        setLoading(false)
      })
  }

  return { templateView: value, getVoucherViewer, isLoading }
}
